<script>
export default {
  name: "no-location"
};
</script>

<template>
  <div
    class="alert alert-custom alert-light-danger fade show mb-5"
    role="alert"
  >
    <div class="alert-icon"><i class="flaticon-warning"></i></div>
    <div class="alert-text">Please setup locations in Step 1</div>
    <div class="alert-close">
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true"><i class="ki ki-close"></i></span>
      </button>
    </div>
  </div>
</template>
